module.exports = __webpack_public_path__ + "img/clement-box1.29e12727.png";